import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { IdeaTopCardFragment } from '../../../../../__generated__/IdeaTopCardFragment';
import { Factoid } from '../Factoid';

interface Props {
  idea: IdeaTopCardFragment;
}

export const FixedFees: React.FC<Props> = ({ idea: { properties } }) => {
  const { t } = useTranslation();

  switch (properties.__typename) {
    case 'Investment_LimitedIdeaProperties':
    case 'Investment_BuyAndHoldIdeaProperties':
      return (
        <>
          <Factoid title={t('For enter')} data-testid="enter-fee">
            {properties.enterFee || 0}
          </Factoid>
          <Factoid title={t('For leave')} data-testid="leave-fee">
            {properties.leaveFee || 0}
          </Factoid>
          <Factoid title={t('For success')} data-testid="success-fee">
            {properties.successFee || 0}
          </Factoid>
        </>
      );

    case 'Investment_UnlimitedIdeaProperties':
      return (
        <>
          <Factoid title={t('For success')} data-testid="success-fee">
            {properties.successFee || 0}
          </Factoid>
          <Factoid title={t('For enter')} data-testid="enter-fee">
            {properties.enterFee || 0}
          </Factoid>
          <Factoid title={t('For management')} data-testid="management-fee">
            {properties.managementFee || 0}
          </Factoid>
        </>
      );
  }
};
